import { render } from "./form-date.vue?vue&type=template&id=34d64570"
import script from "./form-date.vue?vue&type=script&lang=js"
export * from "./form-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__